import { QuestionSearchItem } from '@core/types/types.common';
import { DBQuestion } from '@core/types/types.db';
import { timeAgo } from '@core/util/util.timeAgo';
import { Directory } from '@frontend/shared/components/Directory/Directory';

export function QuestionVerified({
  question,
}: {
  question: QuestionSearchItem | DBQuestion;
}) {
  return (
    <div className="flex text-[#3A3A3A] text-xs font-medium items-center">
      <p className="ml-0">
        Verified by <Directory userId={question.verified_by} />
        {` • ${timeAgo(question.verified_at ?? '')}`}
      </p>
    </div>
  );
}
